import { render, staticRenderFns } from "./modalEditSeasonSetup.vue?vue&type=template&id=24c1bb70&"
import script from "./modalEditSeasonSetup.vue?vue&type=script&lang=js&"
export * from "./modalEditSeasonSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports